import React, {CSSProperties } from 'react'
// @ts-ignore
import { Fireworks, FireworksOptions } from 'fireworks-js/dist/react'

type Props = {
    enableFireworks: boolean;
}

const FireworksAnimation: React.FC<Props> = ({enableFireworks}) => {

    const options: FireworksOptions = {
        speed: 3,
        mouse: {
            max: 3,
            move: false,
            click: true
        }
    }

    const style: CSSProperties = {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: 9999,
        pointerEvents: 'none'
    }

    return (
        <div>
            {enableFireworks && (
                <Fireworks options={options} style={style} />
            )}
        </div>
    )
}

export default FireworksAnimation
